'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _SimpleHero = require('components/SimpleHero');

var _multitrack = require('helpers/multitrack');

var _object = require('helpers/object');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Template = exports.Template = function (_PureComponent) {
  (0, _inherits3.default)(Template, _PureComponent);

  function Template(props) {
    (0, _classCallCheck3.default)(this, Template);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Template.__proto__ || (0, _getPrototypeOf2.default)(Template)).call(this, props));

    _this.handleCtaClick = _this.handleCtaClick.bind(_this);
    _this.handleView = _this.handleView.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Template, [{
    key: 'handleView',
    value: function handleView() {
      var _props = this.props,
          eventName = _props.eventName,
          eventLabel = _props.eventLabel;

      if (eventName) {
        (0, _multitrack.ga)(eventName + ' Module', 'Viewed module', eventLabel || null, 0, { nonInteraction: true });
      }
    }
  }, {
    key: 'handleCtaClick',
    value: function handleCtaClick() {
      var _props2 = this.props,
          eventName = _props2.eventName,
          eventLabel = _props2.eventLabel;


      if (eventName) {
        (0, _multitrack.ga)(eventName + ' Module', 'Clicked CTA', eventLabel);
      }
    }
  }, {
    key: 'renderCta',
    value: function renderCta() {
      var _props3 = this.props,
          ctaCopy = _props3.ctaCopy,
          ctaLink = _props3.ctaLink,
          openInNewTab = _props3.openInNewTab;


      if (!ctaCopy) {
        return false;
      }

      var linkIsFullyQualified = ctaLink && ctaLink.indexOf('http') === 0;
      var useAnchor = linkIsFullyQualified || openInNewTab;

      var cta = void 0;

      if (useAnchor) {
        cta = _react2.default.createElement(
          'a',
          (0, _extends3.default)({ onClick: this.handleCtaClick, href: ctaLink, className: 'bt bt--primary bt--lg' }, openInNewTab ? { target: '_blank' } : {}),
          ctaCopy
        );
      } else {
        cta = _react2.default.createElement(
          _reactRouter.Link,
          { onClick: this.handleCtaClick, to: ctaLink, className: 'bt bt--primary bt--lg' },
          ctaCopy
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'pt--' },
        cta
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var passthroughProps = (0, _object.pick)(['backgroundColor', 'body', 'children', 'footer', 'imageAlignment', 'imageAlt', 'imageUrl', 'title', 'titleSize'], this.props);

      return _react2.default.createElement(_SimpleHero.SimpleHero, (0, _extends3.default)({}, passthroughProps, {
        cta: this.renderCta(),
        onView: this.handleView
      }));
    }
  }]);
  return Template;
}(_react.PureComponent);

Template.propMapper = function (state, moduleDef) {
  return {
    title: moduleDef.title,
    titleSize: moduleDef.titleSize,
    backgroundColor: moduleDef.backgroundColor || 'white',
    body: moduleDef.body,
    footer: moduleDef.footer,
    imageAlignment: moduleDef.imageAlignment,
    imageUrl: moduleDef.image && moduleDef.image.image,
    imageAlt: moduleDef.image && moduleDef.image.altText,
    ctaCopy: moduleDef.cta && moduleDef.cta.title,
    ctaLink: moduleDef.cta && moduleDef.cta.url,
    openInNewTab: moduleDef.openInNewTab,
    eventName: moduleDef.eventName,
    eventLabel: moduleDef.eventLabel
  };
};

Template.propTypes = {
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  body: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  backgroundColor: _propTypes2.default.oneOf(['light', 'white']),
  footer: _propTypes2.default.string,

  imageAlignment: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  imageAlt: _propTypes2.default.string,

  ctaCopy: _propTypes2.default.string,
  ctaLink: _propTypes2.default.string,
  openInNewTab: _propTypes2.default.bool,

  eventName: _propTypes2.default.string,
  eventLabel: _propTypes2.default.string,

  children: _propTypes2.default.node
};